import * as Actions from '../../actions'

const initialState={
    data: {
        items: [],
    },
    isLoading: false,
    error: false
}

const cart=function(state=initialState,action) {
    switch(action.type) {
        case Actions.GET_CART: case Actions.MERGE_CART : case Actions.ADD_TO_CART : case Actions.INCREASE_CART_COUNT : case Actions.DECREASE_CART_COUNT : case Actions.EMPTY_CART: case Actions.REPEAT_ORDER: {
            return {
                ...state,
                isLoading: true,
                error: false
            }
        }
        case Actions.GET_CART_SUCCESS: case Actions.MERGE_CART_SUCCESS : case Actions.ADD_TO_CART_SUCCESS : case Actions.INCREASE_CART_COUNT_SUCCESS : case Actions.DECREASE_CART_COUNT_SUCCESS : case Actions.EMPTY_CART_SUCCESS: case Actions.REPEAT_ORDER_SUCCESS: {
            return {
                ...state,
                data : action.payload,
                isLoading: false,
                error: false
            }
        }
        case Actions.GET_CART_ERROR: case Actions.MERGE_CART_ERROR: case Actions.ADD_TO_CART_ERROR : case Actions.INCREASE_CART_COUNT_ERROR : case Actions.DECREASE_CART_COUNT_ERROR : case Actions.EMPTY_CART_ERROR: case Actions.REPEAT_ORDER_ERROR:{
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }
            
        case Actions.REMOVE_FROM_CART: {
            return {
                ...state,
                isLoading: true,
                error: false
            }
        }
        case Actions.REMOVE_FROM_CART_SUCCESS: {
            const newData=state.data.filter(item => item._id===action.payload)

            return {
                ...state,
                data: newData,
                isLoading: false,
                error: false
            }
        }
        case Actions.REMOVE_FROM_CART_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }


        case Actions.SUBMIT_CART: {
            return {
                ...state,
                isLoading: true,
                error: false
            }
        }
        case Actions.SUBMIT_CART_SUCCESS: {
            return {
                ...state,
                data: [],
                isLoading: false,
                error: false
            }
        }
        case Actions.SUBMIT_CART_ERROR: {
            return {
                ...state,
                isLoading: false,
                error: action.error
            }
        }
        // case Actions.LOGOUT: {
        //     return {
        //         ...state,
        //         isLoading: true,
        //         error: false
        //     }
        // }
        // case Actions.LOGOUT_SUCCESS: {
        //     return {
        //         ...state,
        //         data: {items: []},
        //         isLoading: false,
        //         error: false
        //     }
        // }
        // case Actions.LOGOUT_ERROR: {
        //     return {
        //         ...state,
        //         isLoading: false,
        //         error: action.error
        //     }
        // }

        default: {
            return state
        }
    }
}

export default cart